import { useTranslation } from 'react-i18next';
import SebraeLogo from '../../../assets/images/sebraebranco.png';
import SemagroLogo from '../../../assets/images/semagrobranco.png';
import { ImagesWrapper, SponsorsContainer } from './styles';

const Sponsors = () => {
  const { t } = useTranslation();

  return (
    <SponsorsContainer>
      {t('screens.sponsors.title')}
      <ImagesWrapper>
        <img src={SebraeLogo} alt="SEBRAE Logo" />
        <img src={SemagroLogo} alt="SEMAGRO Logo" />
      </ImagesWrapper>
    </SponsorsContainer>
  );
};

export default Sponsors;
